import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";

const FormEditCompany = () => {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [fax, setFax] = useState("");
  const [msg, setMsg] = useState("");
  const [file, setFile] = useState("");
  const [preview, setPreview] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  // Access the environment variables
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    const getCompanyById = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/companies/${id}`, {
          headers: {
            'X-API-Key': API_KEY
          },
        });
        setName(response.data.name);
        setAddress(response.data.address);
        setEmail(response.data.email);
        setPhone(response.data.phone);
        setFax(response.data.fax);
        setFile(response.data.image);
        setPreview(response.data.url);
      } catch (error) {
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }
    };
    getCompanyById();
  }, [id]);

  const loadImage = (e) => {
    const image = e.target.files[0];
    setFile(image);
    setPreview(URL.createObjectURL(image));
  };

  const updateCompany = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", name);
    formData.append("address", address);
    formData.append("fax", fax);
    formData.append("email", email);
    formData.append("phone", phone);
    try {
      await axios.patch(`${API_BASE_URL}/companies/${id}`, formData, {
         headers: {
          "Content-type": "multipart/form-data",
          'X-API-Key': API_KEY
        },
      });
      navigate("/companies");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };
  return (
    <div className="container">
      <h1 className="title is-size-5">Edit Company</h1>
      <div className="card is-shadowless">
        <form onSubmit={updateCompany}>
          <p className="has-text-centered">{msg}</p>
          <div className="field">
            <label className="label">Name</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Name"
              />
            </div>
          </div>
          <div className="field">
            <label className="label">Address</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Address"
              />
            </div>
          </div>
          <div className="field">
            <label className="label">Email</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
              />
            </div>
          </div>
          <div className="field">
            <label className="label">Phone</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Phone"
              />
            </div>
          </div>              
          <div className="field">
            <label className="label">Fax</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={fax}
                onChange={(e) => setFax(e.target.value)}
                placeholder="Fax"
              />
            </div>
          </div>
          <div className="field">
                <label className="label">Logo</label>
                <div className="control">
                  <div className="file">
                    <label className="file-label">
                      <input
                        type="file"
                        className="file-input"
                        onChange={loadImage}
                      />
                      <span className="file-cta">
                        <span className="file-label">Choose a file...</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              {preview ? (
                <figure className="image is-128x128">
                  <img src={preview} alt="Preview Image" />
                </figure>
              ) : (
                ""
              )}
          <div className="field">
            <div className="control">
              <Link to="/companies">
              <button className="button is-small is-warning mr-1">
                Cancel
              </button>
              </Link>
              <button type="submit" className="button is-small is-success">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormEditCompany;
